/* eslint-disable import/no-cycle */
import { createModule } from '@seedcloud/stateless'

import { AuthService } from './service'

import { withTryCatch } from 'utils/withTryCatch'

const INITIAL_STATE = Object.freeze({
  isBanned: false,
  user: undefined,
})

const setUserBanStatus = (module) => async (_, isBanned) =>
  module.setState({ isBanned })

const getProfile = (module, { setError }) =>
  withTryCatch(
    async () => {
      const user = await AuthService.fetchCurrentAccount()

      module.setState({
        user,
      })

      return user
    },
    {
      onError: (err) => setError(null, err),
    }
  )

const authModule = createModule({
  name: 'auth',
  initialState: INITIAL_STATE,
  decorators: {
    setUserBanStatus,
    getProfile,
  },
})

export { authModule }
